import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CalendarIcon, ClockIcon, CheckCircleIcon, MapPinIcon } from 'lucide-react';
interface VaccineAppointmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  vaccineName: string;
}
export function VaccineAppointmentModal({
  isOpen,
  onClose,
  vaccineName
}: VaccineAppointmentModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      onClose();
    }, 4000);
  };
  return <AnimatePresence data-id="element-293" data-mp="3u7xq1yuyuliw">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100]" data-id="element-294" data-mp="2ul04fa9lpew" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed inset-0 m-auto w-full max-w-xl h-fit bg-white rounded-3xl shadow-2xl z-[101] overflow-hidden" data-id="element-295" data-mp="14rh5lnk4abgz">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-296" data-mp="h2y5vwf4v70i">
              <div className="flex items-center gap-3" data-id="element-297" data-mp="c4wemo7k01dy">
                <div className="w-10 h-10 bg-clinical-blue/10 rounded-xl flex items-center justify-center text-clinical-blue" data-id="element-298" data-mp="750cyvmbwm1k">
                  <CalendarIcon className="w-5 h-5" data-id="element-299" data-mp="26ie6uoiwlmfb" />
                </div>
                <div data-id="element-300" data-mp="21jazgxfgb446">
                  <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight" data-id="element-301" data-mp="21irsucv9425g">
                    Schedule {vaccineName}
                  </h2>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-302" data-mp="3vxf634g7e82f">
                    Secure Appointment Booking
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors" data-id="element-303" data-mp="3r06k0srxpjvw">
                <XIcon className="w-5 h-5 text-slate-400" data-id="element-304" data-mp="ikwlfun96wsv" />
              </button>
            </div>

            <div className="p-8" data-id="element-305" data-mp="niy44egrou3t">
              {submitted ? <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-center py-12" data-id="element-306" data-mp="8mp9xrbqh6y9">
                  <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-307" data-mp="2yckfniavub7z">
                    <CheckCircleIcon className="w-10 h-10" data-id="element-308" data-mp="1gc1o9o4lmwk5" />
                  </div>
                  <h3 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight" data-id="element-309" data-mp="1be9u0ngheycs">
                    Appointment Confirmed!
                  </h3>
                  <p className="text-slate-500 mb-6" data-id="element-310" data-mp="1lcfssw6zrodf">
                    Your {vaccineName} appointment has been scheduled. A
                    confirmation email has been sent to you.
                  </p>
                  <div className="bg-slate-50 p-4 rounded-2xl inline-flex items-center gap-3 text-slate-600 text-sm font-medium" data-id="element-311" data-mp="spczqjl345uk">
                    <MapPinIcon className="w-4 h-4 text-clinical-blue" data-id="element-312" data-mp="16gzw0jf11edc" />
                    Walk-ins are also welcome anytime!
                  </div>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-313" data-mp="dxkwv72h8k9q">
                  <div className="space-y-4" data-id="element-314" data-mp="9wr9cesy57hd">
                    <div className="space-y-2" data-id="element-315" data-mp="9vznhvp5io4a">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-316" data-mp="mo2y8t1l52en">
                        Full Name
                      </label>
                      <input required type="text" placeholder="John Doe" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-317" data-mp="wlhdwqfopn5w" />
                    </div>

                    <div className="grid grid-cols-2 gap-4" data-id="element-318" data-mp="1fbpccv8fvpfr">
                      <div className="space-y-2" data-id="element-319" data-mp="1fc8ileoq8pdy">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-320" data-mp="1kajwc0i57k1g">
                          Email Address
                        </label>
                        <input required type="email" placeholder="john@example.com" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-321" data-mp="3h5es7dhqz7fd" />
                      </div>
                      <div className="space-y-2" data-id="element-322" data-mp="2ztzucki779fv">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-323" data-mp="2zvb02pv7er9m">
                          Phone Number
                        </label>
                        <input required type="tel" placeholder="(555) 000-0000" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-324" data-mp="3sjgjn9aiua7v" />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4" data-id="element-325" data-mp="273rc6snnwp1a">
                      <div className="space-y-2" data-id="element-326" data-mp="z6oifl13kvi0">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-327" data-mp="z3smg28t8gw7">
                          Preferred Date
                        </label>
                        <div className="relative" data-id="element-328" data-mp="p77g9dl20zqs">
                          <input required type="date" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-329" data-mp="u60r0y8yicn9" />
                        </div>
                      </div>
                      <div className="space-y-2" data-id="element-330" data-mp="bfj2z6z2k588">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-331" data-mp="bgan9ln7ugj7">
                          Preferred Time
                        </label>
                        <select required className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all appearance-none" data-id="element-332" data-mp="1gjv3qm4odma">
                          <option value="" data-id="element-333" data-mp="3o17z7ylxda48">Select Time</option>
                          <option data-id="element-334" data-mp="3j00q9w81q4vz">9:00 AM - 11:00 AM</option>
                          <option data-id="element-335" data-mp="3j2wqxsba37o4">11:00 AM - 1:00 PM</option>
                          <option data-id="element-336" data-mp="tmg88cwef2v">1:00 PM - 3:00 PM</option>
                          <option data-id="element-337" data-mp="3syzqcqeqws7d">3:00 PM - 5:00 PM</option>
                          <option data-id="element-338" data-mp="3syhnvc1hphr0">5:00 PM - 7:00 PM</option>
                        </select>
                      </div>
                    </div>

                    <div className="space-y-2" data-id="element-339" data-mp="5l5jry67vz43">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-340" data-mp="5mfkyw8d9ney">
                        Select Store Location
                      </label>
                      <select required className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all appearance-none" data-id="element-341" data-mp="fl4rjsutblfw">
                        <option value="" data-id="element-342" data-mp="36ce2rqjsrvhn">Select Location</option>
                        <option data-id="element-343" data-mp="3bape65pqqe1z">Annapolis Pharmacy (2002 Jennifer Rd)</option>
                      </select>
                    </div>
                  </div>

                  <div className="pt-4" data-id="element-344" data-mp="2do8fox59tuen">
                    <button type="submit" className="w-full bg-clinical-blue text-white font-black py-4 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-345" data-mp="2ikyxbowq4y26">
                      Schedule Appointment
                    </button>
                    <p className="mt-4 text-center text-[10px] text-slate-400 uppercase tracking-widest font-bold" data-id="element-346" data-mp="1uvnum1vtctle">
                      No payment required at this time
                    </p>
                  </div>
                </form>}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}